import { render, staticRenderFns } from "./PagerBar.vue?vue&type=template&id=6895090c&scoped=true&"
import script from "./PagerBar.vue?vue&type=script&lang=js&"
export * from "./PagerBar.vue?vue&type=script&lang=js&"
import style0 from "./PagerBar.vue?vue&type=style&index=0&id=6895090c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895090c",
  null
  
)

export default component.exports